export const BLANK_TEXT = '---';
export const DEFAULT_DECKS_ROUTE = '/decks?rate-type=active';
